"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = void 0;
var isFunction_1 = require("./isFunction");
function isPromise(value) {
    return isFunction_1.isFunction(value === null || value === void 0 ? void 0 : value.then);
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/~/rxjs/dist/cjs/internal/util/isPromise.js
// module id = 841
// module chunks = 0